module.exports = __webpack_public_path__ + "static/property-live-work-macromenu-7d89105746027014420b446dfde73e60.jpg";